module.exports = __webpack_public_path__ + "static/media/eildh3.a255dae8.jpg";